<template>
  <div>
    <!--
    <div class="flex md6 xs12" v-if="optionsSchool">
      <va-select :label="$t('forms.selects.simple')" v-model="simpleSelectModel" textBy="description" track-by="id"
        :options="simpleOptions" searchable  />
    </div>-->

    <va-select v-model="selectedSchool" 
    class="mb-4" 
    label="โรงเรียน" 
    :options="optionsSchool" 
    searchable
    v-if="optionsSchool" />
    <div v-else><va-progress-bar indeterminate/></div>
    <div v-if="optionsSchool">
    </div>


  </div>
</template>
<script>
import axios from "axios";

export default {
  name: "VaIconVuestic",
  components: {},

  props: {

  },

  data() {
    return {
      enterpriseMoo: "",
      selectedProvince: "",
      selectedEditProvince: "",
      selectedDistrict: "",
      selectedAmphur: "",
      selectedEnterprise: null,
      selectedUserType: "",
      selectedSchool: "",
      optionsProvince: null,
      optionsSubdistrict: null,
      optionsAmphur: null,
      optionsSchool: null,
      errorEnterpriseName: false,
      errorEnterpriseAddress: false,
      errorEnterpriseMoo: false,
      errorEnterpriseProvince: false,
      errorEnterpriseSubdistrict: false,
      userTypeInfo: null,
      simpleSelectModel: null,
      simpleOptions: [
        {
          id: 1,
          description: 'First option',
        },
        {
          id: 2,
          description: 'Second option',
        },
        {
          id: 3,
          description: 'Third option',
        },
      ],

    };
  },
  beforeMount() {
    this.selectedSchool = this.$store.state.selectedSchool;
    //FETCH PROVINCE DROPDOWN
    const formData = new FormData();
    formData.append("txtAction", "getSchoolsofSK");
    axios
      .post(this.$store.state.hostUrl + "schoolAPI.php", formData)
      .then((response) => {
        //console.log(response.data);
        this.optionsSchool = response.data.mainData;
        //console.log(this.optionsSchool);
      })
      .catch(function (error) {
        console.log(error);
      });
  },
  computed: {},
  watch: {
    selectedSchool(newData) {
      //console.log(newData);
      this.$store.commit("mutateSelectedSchool", newData);
    },
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.sticky-table-example {
  .va-data-table {
    border: 1px solid;
  }

  .va-data-table+.va-data-table {
    margin-top: 2rem;
  }

  .my-custom-table-class {
    &.va-data-table--sticky {
      height: 180px;

      .va-data-table__table-thead--sticky {
        background-color: #262824;

        .va-data-table__table-th {
          color: white;
        }
      }
    }
  }
}
</style>
